import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getLeadOppProducts } from '../api'
import { ENTITY_TYPES } from '@sales-center/common'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'
import { guestRoleName } from '@user/components/Settings/Users/UpdateUser/constants'

export const useGetLeadOppProductsOnMount = (
  entityId: number,
  entityType: ENTITY_TYPES,
) => {
  const dispatch = useAppDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const isGuestUser = currentUser?.roleName === guestRoleName

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (!isGuestUser) {
        try {
          setStatus('pending')
          const result = await dispatch(
            getLeadOppProducts({ entityId, entityType }),
          )

          if (mounted) {
            if (getLeadOppProducts.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        }
      } else {
        setStatus('success')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, entityId, entityType, isGuestUser])

  return status
}
